import {
  SET_LOGIN,
  SetLoginAction,
  SET_LOGOUT,
  SetLogoutAction,
  SET_RECAPTCHA_CODE_STATE,
  SetRecaptchaCodeAction,
} from "../actions-Types/authActionTypes";
import { Dispatch } from "redux";

interface LoginData {
  email?: string;
  password?: string;
  username?: string;
}

export const loginDetails =
  (data: LoginData) => async (dispatch: Dispatch<SetLoginAction>) => {
    try {
      dispatch({
        type: SET_LOGIN,
        payload: data,
      });
    } catch (err) {
      console.error("Failed to dispatch login action", err);
    }
  };
export const setUserLogoutData =
  () => async (dispatch: Dispatch<SetLogoutAction>) => {
    try {
      dispatch({
        type: SET_LOGOUT,
        payload: undefined,
      });
    } catch (err) {
      console.error("Failed to dispatch Logout action", err);
    }
  };

export const setRecaptchaCodeState =
  (value: string) => async (dispatch: Dispatch<SetRecaptchaCodeAction>) => {
    try {
      dispatch({
        type: SET_RECAPTCHA_CODE_STATE,
        payload: value,
      });
    } catch (err) {
      console.error("Failed to dispatch recaptcha code action", err);
    }
  };
